import { render } from "./SkeletonComponent.vue?vue&type=template&id=6b907558&scoped=true&ts=true"
import script from "./SkeletonComponent.vue?vue&type=script&lang=ts"
export * from "./SkeletonComponent.vue?vue&type=script&lang=ts"

import "./SkeletonComponent.vue?vue&type=style&index=0&id=6b907558&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b907558"]])

export default __exports__